import { VENDORINVOICES } from '../actionTypes';

export const fetchVendorInvoices = (payload) => ({
  type: VENDORINVOICES.FETCH,
  payload,
});
